<div class="container-fluid box page-not-found">
        <img src="assets/Page_Not_Found/404 .svg" alt="" class="not-found-img">
        <div class="not-found-message">
            <h2>Page not found</h2>
            <p>Oops, looks like you are lost. Let's get you back to pavilion. </p>
            <button type="button" class="btn btn-border" (click)="navigateToHome()">Back to home</button>
        </div>
</div>
